import React from 'react'
import PropTypes from 'prop-types'
import {useMultiStyleConfig} from '@chakra-ui/react'
import DrawerTemplateOne from './templates/DrawerTemplateOne'
import DrawerTemplateTwo from './templates/DrawerTemplateTwo'
import DrawerTemplateThree from './templates/DrawerTemplateThree'
import DrawerTemplateFour from './templates/DrawerTemplateFour'

const TEMPLATE_BY_VARIANT = {
    'template-one': DrawerTemplateOne,
    'template-two': DrawerTemplateTwo,
    'template-three': DrawerTemplateThree,
    'template-four': DrawerTemplateFour,
}

const DrawerTemplate = ({primarycategory, categoryData, locale, variant}) => {
    const styles = useMultiStyleConfig('MenuTemplate', {variant: 'template-one'})
    const Template = TEMPLATE_BY_VARIANT[variant]

    if (!Template) return null

    return (
        <Template
            primarycategory={primarycategory}
            categoryData={categoryData}
            locale={locale}
            styles={styles}
        />
    )
}

DrawerTemplate.propTypes = {
    primarycategory: PropTypes.object,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
    variant: PropTypes.oneOf(['template-one', 'template-two', 'template-three', 'template-four'])
        .isRequired,
}

export {DrawerTemplate}
